import { SelectOption } from '@globaleris/ui.library'
import moment from 'moment'
import { EnumCommodity, EnumTipoPeaje } from '../../api'
import { EnumEstadoLead } from '../../api/oData/enums/enumEstadoLead'
import {
  AnnexedLeadModel,
  EvaluateLeadRequestModel,
  LeadAnnouncementResponseModel,
  LeadConsumptionQuantityByProfileRequestModel,
  LeadConsumptionQuantityModel,
  LeadModel,
  LeadQueryModel,
  LeadsSearchFilterModel
} from '../../api/Argentia/endpoints/leads/model/leads'
import {
  QuotesModel,
  ReEvaluateQuoteRequestModel
} from '../../api/Argentia/endpoints/quotes/model/quotes'
import { AnnexedParamSectionTableModel } from '../../components/shared/annexedParamAccordionSection/annexedParamAccordionSection.model'
import { QuantityAssistantDataTableRow } from '../../components/shared/quantityAssistantModal/quantityAssistantModal.model'
import { enumTranslateOption } from '../../helpers'
import { generateIconsFromConfiguration } from '../../helpers/dataTableActionIconHelper'
import i18n from '../../i18n'
import { ActionIcons, DataTableActionConfiguration } from '../../model'
import { getActiveCompany } from '../../redux'
import { LeadFormModel } from './components/leadForm/leadForm'
import { LeadFormSearchFilter } from './components/searchFilterCard/searchFilterCard'
import { EvaluateLeadModel, LeadInfoCardModel, LeadRequestModel } from './leads.model'
import { ProfileQuantityFormModel } from './profiles/consumption/profile/components/profileQuantityCard'

// export const mapLeadsResponseToModel = (leads: LeadModel[]): LeadModel[] => {
//   return leads.map(lead => mapLeadResponseToModel(lead))
// }

// export const mapLeadResponseToModel = (lead: LeadModel): LeadModel => {
//   return {
//     id: lead.id,
//     code: lead.code,
//     description: lead.description,
//     leadType: lead.leadType,
//     product: {
//       id: lead.product.id,
//       code: lead.product.code,
//       description: lead.product.description
//     },
//     commodity: lead.commodity,
//     tollType: lead.tollType,
//     supplyPoint: lead.supplyPoint
//       ? {
//           id: lead.supplyPoint.id,
//             code: lead.supplyPoint.cupsCode,
//             description: lead.supplyPoint.cupsDescription

//         }
//       : undefined,
//     annexedLead: mapArgentiaAnnexedLeadsToModel(lead.annexedLead)
//   }
// }

// export const mapArgentiaAnnexedLeadsToModel = (
//   leads: AnnexedLeadArgentiaModel[]
// ): AnnexedLeadModel[] => {
//   return leads.map(lead => mapArgentiaAnnexedLeadToModel(lead))
// }

// export const mapArgentiaAnnexedLeadToModel = (lead: AnnexedLeadArgentiaModel): AnnexedLeadModel => {
//   return {
//     annexedLeadId: lead.annexedLeadId,
//     leadId: lead.leadId,
//     annexedParam: lead.annexedParam,
//     value: lead.value
//   }
// }

export const mapTollsResponseToSelectOption = (tolls: any[]): SelectOption[] => {
  return tolls.map(toll => mapTollResponseToSelectOption(toll))
}

export const mapTollResponseToSelectOption = (toll: any): SelectOption => {
  return {
    value: toll.id,
    label: toll.description
  }
}

export const mapAddLeadFormToPostRequest = (
  formData: LeadFormModel,
  annexedLeadArray: AnnexedParamSectionTableModel[]
): LeadRequestModel => {
  return {
    ...(formData.id && { id: formData.id }),
    code: formData.code,
    description: formData.description || undefined,
    commentaries: formData.commentaries || undefined,
    leadType: formData.leadType,
    commodity: formData.commodity,
    weightedType: formData.weightedType,
    breakdownLevel: formData.breakdownLevel,
    profile: formData.profileId
      ? {
          id: formData.profileId
        }
      : undefined,
    tollType: formData.tollId,
    product: formData.productId
      ? {
          id: formData.productId
        }
      : undefined,
    // supplyPoint: formData.supplyPointId
    //   ? {
    //       id: formData.supplyPointId
    //     }
    //   : undefined,
    annexedLead: mapAnnexedLeadTableToAnnexedLeadModel(annexedLeadArray),
    companyId: getActiveCompany()?.id!,
    leadState: formData.leadState
  }
}

const mapAnnexedLeadTableToAnnexedLeadModel = (
  annexedLeadArray: AnnexedParamSectionTableModel[]
) => {
  return annexedLeadArray.map(annexedLead => mapAnnexedLeadToAnnexedLeadModel(annexedLead))
}

const mapAnnexedLeadToAnnexedLeadModel = (
  annexedLead: AnnexedParamSectionTableModel
): AnnexedLeadModel => {
  return {
    annexedParam: annexedLead.annexedParam,
    value: annexedLead.value
  }
}

export const mapLeadFormSearchToFilterRequest = (
  formData: LeadFormSearchFilter
): LeadsSearchFilterModel => {
  return {
    code: formData.code,
    commodity: formData.commodity,
    description: formData.description,
    leadType: formData.leadType,
    productId: formData.productId,
    tollTypeId: formData.tollTypeId
  }
}

export const mapLeadModelToLeadFormModel = (lead: LeadModel): LeadFormModel => {
  return {
    id: lead.id,
    commodity: lead.commodity,
    leadType: lead.leadType,
    code: lead.code,
    description: lead.description,
    breakdownLevel: lead.breakdownLevel,
    weightedType: lead.weightedType,
    profileId: lead.profile?.id,
    productId: lead.product?.id,
    tollId: lead.tollType,
    supplyPointId: lead.supplyPoint?.id,
    leadState: lead.leadState
  }
}

export const mapLeadModelToAnnexedParamSectionTableModel = (
  lead: LeadModel
): AnnexedParamSectionTableModel[] => {
  return lead.annexedLead.map(leadAnnexedParam =>
    mapAnnexedLeadModelToAnnexedLeadTableModel(leadAnnexedParam)
  )
}

export const mapAnnexedLeadModelToAnnexedLeadTableModel = (
  leadAnnexedParam: AnnexedLeadModel
): AnnexedParamSectionTableModel => {
  return {
    entityId: leadAnnexedParam.leadId,
    annexedEntityId: leadAnnexedParam.annexedLeadId,
    annexedParam: leadAnnexedParam.annexedParam,
    description: leadAnnexedParam.annexedParamDescription,
    detailedDescription: leadAnnexedParam.annexedParamDetailDesc,
    valueType: leadAnnexedParam.valueType!,
    value: leadAnnexedParam.value
  }
}

export const mapResponseToLeadInfoObject = (data: LeadQueryModel): LeadInfoCardModel => {
  return {
    code: data.code,
    description: data.description,
    product: data.product,
    tollType: data.tollType,
    commodity: data.commodity,
    leadType: data.leadType
  }
}

export const mapResponseToLeadInfoMap = (data: LeadQueryModel): Record<string, string> => {
  return {
    product: data?.product?.description ?? '',
    tollType: data?.tollType
      ? enumTranslateOption(data?.tollType, EnumTipoPeaje, 'enums:EnumTipoPeaje')
      : '',
    commodity: enumTranslateOption(data?.commodity, EnumCommodity, 'enums:EnumCommodity')
  }
}

export const mapLeadQueryToForm = (leadQuery: LeadQueryModel): LeadFormModel => {
  return {
    id: leadQuery.id,
    commodity: leadQuery.commodity,
    leadType: leadQuery.leadType,
    leadState: leadQuery.leadState,
    breakdownLevel: leadQuery.breakdownLevel,
    weightedType: leadQuery.weightedType,
    profileId: leadQuery.profile?.id,
    code: leadQuery.code,
    description: leadQuery.description,
    commentaries: leadQuery.commentaries,
    productId: leadQuery.product?.id,
    tollId: leadQuery.tollType
  }
}

export const mapLeadQueryArrayToParamsTable = (
  annexedLead: AnnexedLeadModel[]
): AnnexedParamSectionTableModel[] => {
  return annexedLead.map(element => mapLeadQueryElementToParamsTable(element))
}

export const mapLeadQueryElementToParamsTable = (
  annexedLead: AnnexedLeadModel
): AnnexedParamSectionTableModel => {
  return {
    entityId: annexedLead.leadId,
    annexedEntityId: annexedLead.annexedLeadId,
    annexedParam: annexedLead.annexedParam,
    description: annexedLead.annexedParamDescription,
    detailedDescription: annexedLead.annexedParamDetailDesc,
    valueType: annexedLead.valueType!,
    value: annexedLead.value
  }
}

export const mapLeadAnnoucementsToLeadTable = (
  announcements: LeadAnnouncementResponseModel[]
): LeadModel[] => {
  return announcements.map(announcement => mapLeadAnnoucementsItemToLeadTable(announcement))
}

export const mapLeadAnnoucementsItemToLeadTable = (
  announcement: LeadAnnouncementResponseModel
): LeadModel => {
  return {
    id: announcement.id,
    code: announcement.code,
    description: announcement.description,
    leadType: announcement.leadType,
    commodity: announcement.commodity,
    tollType: announcement.tollType,
    product: announcement.product,
    hasObjections: announcement.hasObjections,
    actions: announcement.actions,
    actionsConfiguration: announcement.actionsConfiguration,
    annexedLead: [],
    companyId: announcement.companyId
  }
}

export const mapRowLeadModelToRequest = (
  rowSelected: EvaluateLeadModel
): EvaluateLeadRequestModel => {
  return {
    idLead: rowSelected.id,
    codOferta: null,
    descripcion: null,
    fechaInicio: rowSelected.startDate ? moment(rowSelected.startDate).format('YYYY-MM-DD') : null,
    fechaFin: rowSelected.endDate ? moment(rowSelected.endDate).format('YYYY-MM-DD') : null
  }
}

export const mapRowLeadModelToPublishQuoteMassiveRequest = (rowSelected: LeadModel): number => {
  return rowSelected.id
}

export const mapRowQuoteModelToRequest = (
  rowSelected: QuotesModel
): ReEvaluateQuoteRequestModel => {
  return {
    idOferta: rowSelected.id
  }
}

export const mapQuantityDataTableToRequest = (
  data: QuantityAssistantDataTableRow[],
  leadData: LeadModel | undefined,
  formData: ProfileQuantityFormModel
): LeadConsumptionQuantityByProfileRequestModel => {
  return {
    idLead: leadData?.id!,
    idProfile: formData?.profileId!,
    weightedType: formData?.weightedType!,
    breakdownLevel: formData?.breakdownLevel!,
    companyId: getActiveCompany()?.id!,
    commodity: leadData?.commodity!,
    product: {
      id: leadData?.product?.id!
    },
    supplyPoint: {
      id: leadData?.supplyPoint?.id
    },
    details: mapQuantityDetailsToRequest(data, formData.unitMeasure)
  }
}

export const mapQuantityDetailsToRequest = (
  data: QuantityAssistantDataTableRow[],
  measureUnit: number | undefined
): LeadConsumptionQuantityModel[] => {
  return data.map(item => ({
    quantityDetail: item.quantity,
    startDate: moment(item.startDate).format('YYYY-MM-DD'),
    endDate: moment(item.endDate).format('YYYY-MM-DD'),
    measureUnit: measureUnit!
  }))
}

export const mapServiceResponseToLeadModel = (
  leads: LeadModel[] | LeadAnnouncementResponseModel[]
): LeadModel[] | LeadAnnouncementResponseModel[] => {
  return leads.map(lead => mapServiceResponseItemToLeadModel(lead))
}

const mapServiceResponseItemToLeadModel = (
  lead: LeadModel | LeadAnnouncementResponseModel
): LeadModel | LeadAnnouncementResponseModel => {
  return {
    ...lead,
    actionsConfiguration: getGlobalActionsConfiguration()
  }
}

export const getGlobalActionsConfiguration = (): Array<DataTableActionConfiguration> => {
  return [getObjectionsDisagreementAction()]
}

const getObjectionsDisagreementAction = (): DataTableActionConfiguration => {
  return {
    icon: ActionIcons.ERROR,
    tooltip: i18n.t('leads:components.leadTable.table.tooltips.objectionsError')
  }
}

export const completeDataTableActions = (
  items: LeadModel[] | LeadAnnouncementResponseModel[]
): LeadModel[] | LeadAnnouncementResponseModel[] => {
  return items.map(item => completeDataTableItemActions(item))
}

export const completeDataTableItemActions = (
  item: LeadModel | LeadAnnouncementResponseModel
): LeadModel | LeadAnnouncementResponseModel => {
  return {
    ...item,
    actions:
      item.actionsConfiguration &&
      item.actionsConfiguration.length > 0 &&
      generateIconsFromConfiguration(
        item,
        filterApplicableActionsConfiguration(item, item.actionsConfiguration),
        new Map<ActionIcons, Function>([]) // optional - empty handlers
      )
  }
}

export const filterApplicableActionsConfiguration = (
  item: LeadModel | LeadAnnouncementResponseModel,
  configurations: Array<DataTableActionConfiguration>
): Array<DataTableActionConfiguration> => {
  let applicableActionsConfiguration: Array<DataTableActionConfiguration> = []
  configurations.forEach(configuration => {
    switch (configuration.icon) {
      case ActionIcons.ERROR: {
        if (item.hasObjections === true) {
          applicableActionsConfiguration.push(configuration)
        }
        break
      }
      case ActionIcons.LOADING: {
        applicableActionsConfiguration.push(configuration)
        break
      }
    }
  })
  return applicableActionsConfiguration
}
